import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ITestRepository from '../../2_domain/test/iTestRepository';
import { TestItemSummary } from '../../2_domain/test/test';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';

const useTestInformationDetailPageController = (serial?: Serial) => {
  const testRepo = Get.find<ITestRepository>('ITestRepository');
  const { itemCode } = useParams();
  const [testItem, setTestItem] = useState<TestItemSummary>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    promiseResolver({
      promise: testRepo.getTestItemDetailById(serial ?? (itemCode as any)),
      isLoadingCallback: setLoading,
      successCallback: (data) => {
        setTestItem(data);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    testItem,
    loading,
  };
};

export default useTestInformationDetailPageController;
